import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";
import { getFutureValueFactor } from "web_myplann/Shared/Utils/getFutureValueFactor";

export const requiredMonthlySavings = (
	savingsTarget: number,
	annualRate: number,
	months: number,
): number => {
	if (savingsTarget <= 0 || months <= 0) return 0;
	return (
		savingsTarget / getFutureValueFactor(annualRate / MONTHS_IN_YEAR, months)
	);
};
